var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9968 25.9969C29.2103 25.9898 28.3788 26.0032 27.5923 25.9993C27.0055 25.9993 26.4636 25.9993 25.8555 25.9993V9.771e-06H26.1591C27.3258 9.771e-06 28.4929 9.771e-06 29.6605 9.771e-06C29.7729 9.771e-06 29.8686 0 29.9968 0V25.9969Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84375 19.4943C1.67885 19.4872 2.51016 19.4793 3.34298 19.4754C3.88276 19.4754 4.42254 19.4754 4.98434 19.4754V25.9992H4.48203C3.31795 25.9992 2.27837 25.9992 1.11175 25.9992C0.998636 25.9992 1.11175 25.9992 0.846027 25.9992L0.84375 19.4943Z",
    fill: "#13E002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4082 25.9992V3.99985H23.2599V25.9992H19.4082Z",
    fill: "#13E002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4826 25.9993H13.6309V8.99979H17.4826V25.9993Z",
    fill: "#13E002"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7034 25.9993H6.88867V14.9996H11.7034V25.9993Z",
    fill: "#13E002"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourBars);
export default __webpack_public_path__ + "static/media/fourBars.fe26384e28171a2fb0281548ada844dc.svg";
export { ForwardRef as ReactComponent };